class ComparaisonTable2Section {
  constructor(container) {
    this.container = container;
    this.rows = container.querySelectorAll(".comparaison-table-2__row");
    this.ourProductCells = container.querySelectorAll(
      ".comparaison-table-2__cell--our-product"
    );
    this.competitorCells = container.querySelectorAll(
      ".comparaison-table-2__cell--competitor"
    );

    this.init();
  }

  init() {
    this.bindEvents();
    this.setupInitialState();
  }

  bindEvents() {
    document.addEventListener(
      "shopify:section:load",
      this.handleSectionLoad.bind(this)
    );
    document.addEventListener(
      "shopify:section:unload",
      this.handleSectionUnload.bind(this)
    );
    window.addEventListener("resize", this.handleResize.bind(this));
  }

  setupInitialState() {
    this.updateLayout();
  }

  updateLayout() {
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      this.container.classList.add("comparaison-table-2--mobile");
      this.optimizeForMobile();
    } else {
      this.container.classList.remove("comparaison-table-2--mobile");
      this.optimizeForDesktop();
    }
  }

  optimizeForMobile() {
    this.rows.forEach((row) => {
      const competitorCell = row.querySelector(
        ".comparaison-table-2__cell--competitor"
      );
      if (competitorCell) {
        competitorCell.style.flexDirection = "column";
      }
    });
  }

  optimizeForDesktop() {
    this.rows.forEach((row) => {
      const competitorCell = row.querySelector(
        ".comparaison-table-2__cell--competitor"
      );
      if (competitorCell) {
        competitorCell.style.flexDirection = "row";
      }
    });
  }

  handleResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.updateLayout();
    }, 250);
  }

  handleSectionLoad(e) {
    if (e.detail.sectionId === this.container.getAttribute("data-section-id")) {
      this.setupInitialState();
    }
  }

  handleSectionUnload(e) {
    if (e.detail.sectionId === this.container.getAttribute("data-section-id")) {
      clearTimeout(this.resizeTimeout);
    }
  }
  refresh() {
    this.setupInitialState();
  }
  addKeyboardNavigation() {
    this.rows.forEach((row, index) => {
      row.setAttribute("tabindex", "0");
      row.setAttribute("role", "row");
      row.setAttribute("aria-label", `Comparison row ${index + 1}`);
    });
  }
  measurePerformance() {
    const startTime = performance.now();
    this.updateLayout();

    const endTime = performance.now();
  }
}
function initComparaisonTable2Sections() {
  const comparaisonTable2Sections = document.querySelectorAll(
    '[data-section-type="comparaison-table-2"]'
  );

  comparaisonTable2Sections.forEach((section) => {
    if (!section.ComparaisonTable2Instance) {
      section.ComparaisonTable2Instance = new ComparaisonTable2Section(section);
      section.ComparaisonTable2Instance.addKeyboardNavigation();
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initComparaisonTable2Sections);
} else {
  initComparaisonTable2Sections();
}
document.addEventListener("shopify:section:load", (e) => {
  if (e.target.querySelector('[data-section-type="comparaison-table-2"]')) {
    initComparaisonTable2Sections();
  }
});

window.ComparaisonTable2Section = ComparaisonTable2Section;
const existingStyles = document.querySelector(
  "#comparaison-table-2-dynamic-styles"
);
if (existingStyles) {
  existingStyles.remove();
}
